import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import AppHeader from '../../components/AppHeader';
import AppFooter from "../../components/AppFooter";
import ImageRadioPicker from "../../components/ImageRadioPicker";
import {LuikType} from "../../Model";
import paneelluikImage from '../../images/luik/paneelluik.jpg'
import louvreluikImage from '../../images/luik/louvreluik.jpg'
import vlakluikImage from '../../images/luik/vlakluik.jpg'
import vensterluikZichtbaarImage from '../../images/luik/vensterluikZichtbaar.jpg'
import vensterluikOnzichtbaarImage from '../../images/luik/vensterluikOnzichtbaar.jpg'
import otherImage from '../../images/template/other1.png'
import PropTypes from "prop-types";

TypePick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
}

export default function TypePick(props) {
    const currentValue = props.allValues.TypePick;

        return (
            <div className="page">
                <AppHeader title="Luiktype"/>

                <div className="page-middle">
                    <h1 className="pick-title">Voor welk luiktype heeft u beslag nodig?</h1>

                    <div className="pick-body">
                        <ImageRadioPicker onSelect={props.handlePageChange}
                                          current={currentValue}
                                          value={LuikType.PANEELLUIK}
                                          image={paneelluikImage}/>
                        <ImageRadioPicker onSelect={props.handlePageChange}
                                          current={currentValue}
                                          value={LuikType.LOUVRELUIK}
                                          image={louvreluikImage}/>
                        <ImageRadioPicker onSelect={props.handlePageChange}
                                          current={currentValue}
                                          value={LuikType.VLAKLUIK}
                                          image={vlakluikImage}
                                          hintText={"Voor- en achterzijde gelijk, vlakke plaat"}/>
                        <ImageRadioPicker onSelect={props.handlePageChange}
                                          current={currentValue}
                                          value={LuikType.VENSTERLUIK_VISIBLE_CLAMS}
                                          image={vensterluikZichtbaarImage}
                                          hintText={"Klampen in het zicht als de luiken open zijn"}/>
                        <ImageRadioPicker onSelect={props.handlePageChange}
                                          current={currentValue}
                                          value={LuikType.VENSTERLUIK_INVISIBLE_CLAMS}
                                          image={vensterluikOnzichtbaarImage}
                                          hintText={"Klampen naar de muur als de luiken open zijn"}/>
                        <ImageRadioPicker onSelect={props.handlePageChange}
                                          current={currentValue}
                                          value={{value: LuikType.OTHER, text: ""}}
                                          child
                                          image={otherImage}/>
                    </div>
                </div>
                <AppFooter onNext={props.handleNextPage}
                           onPrevious={props.handlePreviousPage}
                           enableNext={currentValue}/>
            </div>
        );
}
